import React, { useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import { translations } from 'src/constants/translations';
import { ButtonApp } from 'src/components/ApartmentPageV2/Button';
import { BorderLinearProgress } from 'src/components/profileComponents/EditComplex/components/BorderLinearProgress';
import { ComplexModal } from 'src/components/profileComponents/Complexes/components/ComplexModal';
import { IComplex } from 'src/typings/complexes';
import { useHistory } from 'react-router-dom';
import { useStyles } from './styles';

export const ComplexOverview: React.FC<{complex: IComplex, fetchComplex: () => void}> = ({ complex, fetchComplex }) => {
  const styles = useStyles();
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const goToProject = () => {
    history.push(`/${complex.id}`);
  };
  const estimatedCompletion = useMemo(() => {
    return complex.developmentSpecification?.completionDates[0]?.name[complex.language] || '';
  }, [complex]);

  const placementsAvailablePercent: number = useMemo(() => {
    return (complex.placementsAvailable !== undefined
    && complex.placementsTotalCount !== undefined)
      ? ((complex.placementsAvailable / complex.placementsTotalCount) * 100)
      : 0;
  }, [complex]);

  return (
    <>
      <Box p="24px" className={styles.projectOverviewWrapper}>
        <Box className={styles.projectOverview}>{translations.projectOverview}</Box>
        {estimatedCompletion && (
          <Box className={styles.overviewCard}>
            <div className="title">{translations.estimatedCompletion}</div>
            <div className="value">{estimatedCompletion}</div>
          </Box>
        )}
        <Box className={styles.overviewCard}>
          <div className="title">{translations.unitsForSale}</div>
          <div className="value">{complex.placementsAvailable}</div>
          <div className="progress">
            <BorderLinearProgress variant="determinate" value={placementsAvailablePercent} />
          </div>
        </Box>
        {complex.supervisorsAndManagersCount !== undefined && (
          <Box className={styles.overviewCard}>
            <div className="title">{translations.usersWithAccess}</div>
            <div className="value">{complex.supervisorsAndManagersCount}</div>
          </Box>
        )}
        <Box className={styles.actions}>
          <ButtonApp
            className="btn goToProject"
            onClick={goToProject}
          >
            Go to project
          </ButtonApp>
          <ButtonApp
            className="btn editProject"
            onClick={() => setModalOpen(true)}
          >
            Edit profile
          </ButtonApp>
        </Box>
      </Box>
      {modalOpen && (
      <ComplexModal
        isOpen={modalOpen}
        handleChangeOpen={setModalOpen}
        refreshComplexes={fetchComplex}
        complex={complex}
      />
      )}
    </>
  );
};
